import { render } from "./CallActions.vue?vue&type=template&id=20139105&scoped=true"
import script from "./CallActions.vue?vue&type=script&lang=js"
export * from "./CallActions.vue?vue&type=script&lang=js"

import "./CallActions.vue?vue&type=style&index=0&id=20139105&scoped=true&lang=css"
import "./CallActions.vue?vue&type=style&index=1&id=20139105&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20139105"]])

export default __exports__